import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=805a7154&scoped=true&"
import script from "./FooterContact.vue?vue&type=script&lang=ts&"
export * from "./FooterContact.vue?vue&type=script&lang=ts&"
import style0 from "./FooterContact.vue?vue&type=style&index=0&id=805a7154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805a7154",
  null
  
)

export default component.exports